import {} from "../actions/types";
import { getFirmDocsDisplayName, getMatterLink } from "../utilities/utilities";

//
const initialState = {
	myOpenMatters: [],
	myFavoriteDocuments: [],
	dataUsage: {},
	dataUsageV2: {},
	usageLimits: {},
	tenantFeatures: {},
	tenantUsage: {},
	loading: true,
	// the last refresh was rate limited, so the homepage tables may be out of date
	homepageStale: false,
};

export default function (state = initialState, action) {
	switch (action.type) {
		case "FETCH_HOMEPAGE_SUCCESS":
			return {
				...state,
				myOpenMatters: action.payload.myOpenMatters,
				myFavoriteDocuments: action.payload.myFavoriteDocuments.map(
					(d) => ({ ...d, type: "File" })
				),
				myFavoriteFolders: action.payload.myFavoriteFolders.map((d) => {
					let linkToMatter = getMatterLink(d.mappedMatterID);
					let matterName = d.matterName
						? d.matterName
						: getFirmDocsDisplayName(d.mappedMatterID);

					return {
						...d,
						type: "Folder",
						linkToMatter,
						matterName,
					};
				}),
				dataUsage: action.payload.dataUsage,
				dataUsageV2: action.payload.dataUsageV2,
				usageLimits: action.payload.tenantLimits,
				tenantFeatures: action.payload.tenantFeatures,
				tenantUsage: action.payload.tenantUsage,
				loading: false,
				homepageStale: false,
			};
		case "FETCH_HOMEPAGE_FAILURE":
			return {
				...state,
				homepageStale: !!action.payload?.rateLimited,
			};
		case "TOGGLE_FAVORITE_SUCCESS": {
			const { isFavorite, documentData } = action.payload || {};
			if (!documentData) return state;
			const filtered = state.myFavoriteDocuments.filter(
				(d) => d.id !== documentData.id
			);
			return {
				...state,
				myFavoriteDocuments: isFavorite
					? [...filtered, { ...documentData, type: "File" }]
					: filtered,
			};
		}
		case "UPDATE_LIMITS_AND_FEATURES":
			return {
				...state,
				usageLimits: action.payload.tenantLimits,
				tenantFeatures: action.payload.tenantFeatures,
			};
		default:
			return state;
	}
}
